var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 22.5H28.5V18C28.5 16.8065 28.0259 15.6619 27.182 14.818C26.3381 13.9741 25.1935 13.5 24 13.5C22.8065 13.5 21.6619 13.9741 20.818 14.818C19.9741 15.6619 19.5 16.8065 19.5 18V22.5H18C17.6022 22.5 17.2206 22.658 16.9393 22.9393C16.658 23.2206 16.5 23.6022 16.5 24V33C16.5 33.3978 16.658 33.7794 16.9393 34.0607C17.2206 34.342 17.6022 34.5 18 34.5H30C30.3978 34.5 30.7794 34.342 31.0607 34.0607C31.342 33.7794 31.5 33.3978 31.5 33V24C31.5 23.6022 31.342 23.2206 31.0607 22.9393C30.7794 22.658 30.3978 22.5 30 22.5ZM21 18C21 17.2044 21.3161 16.4413 21.8787 15.8787C22.4413 15.3161 23.2044 15 24 15C24.7956 15 25.5587 15.3161 26.1213 15.8787C26.6839 16.4413 27 17.2044 27 18V22.5H21V18ZM30 33H18V24H30V33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.ef880c45a76fab830c00735f60c4ce15.svg";
export { ForwardRef as ReactComponent };